import { v4 as uuidv4 } from 'uuid';


export default class SaveItem {
    constructor(parent) {
        this.parent = parent;
        this.templateSettings = { 
            interpolate: /(?:<%=|{{)([\s\S]+?)(?:%>|}})/g,
        };
    }

    uuid() {
        return uuidv4();
    }

    render({ utils }) {
        if (this.template) {
            const data = { ...this.data } ; 
            Object.entries(data).forEach(([key, value]) => {
                if(typeof value === "string") {
                    data[key] = value.replace(/{([^}]+)}/g, '');
                }
            })

            return this.template({ data, utils });
        }
    }

    remove() {
        this.parent.remove(this);
    }

    save() {
        const params = Object.fromEntries(this.router.params);
        const json = localStorage.getItem('SaveForLater');
        const data = json ? JSON.parse(json) : [];
        data.push(this.data(params));
        localStorage.setItem('SaveForLater', data);
    }

    boolean(b) {
        return b === true || b === 'true';
    }
}